import React from "react";

/**
 * 渲染报价工作台标题和必填项说明。
 * @returns {JSX.Element} 报价标题
 */
export default function Title() {
  return (
    <div className="quote-page-heading">
      <div>
        <p className="quote-page-eyebrow">PCB Prototype · Online Quote</p>
        <h2>PCB Instant Quote</h2>
      </div>
      <p className="sub-title">
        Configure PCB specifications and get an estimated price online.
        <em> Fields marked with * are mandatory.</em>
      </p>
    </div>
  );
}
